exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".coproff-csv-btn[data-v-4cd0f146]{cursor:pointer;display:flex;align-items:center;justify-content:center;padding:.5rem 1rem;border-radius:3px;transition:background-color .15s ease-in-out}.statestabshadow[data-v-4cd0f146]{box-shadow:1px -3px 6px -6px #000}", ""]);

// exports
